import { Loader2, Construction } from "lucide-react";

export const Loader = ({ label = "Loading" }) => (
  <div className="flex items-center gap-2 text-slate-500 py-16 justify-center" data-testid="loader"><Loader2 className="h-5 w-5 animate-spin text-teal-600" /> {label}…</div>
);

export const PageHeader = ({ title, subtitle, actions, eyebrow }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
    <div>
      {eyebrow && <span className="cz-eyebrow mb-3">{eyebrow}</span>}
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 mt-2" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-slate-500 mt-1.5 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, hint, testid, tone = "teal" }) => (
  <div className="cz-card p-5" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-slate-500">{label}</span>
      {Icon && <span className={`h-9 w-9 rounded-xl grid place-items-center ${tone === "amber" ? "bg-amber-50 text-amber-600" : tone === "navy" ? "bg-slate-100 text-[#003B2D]" : "bg-teal-50 text-teal-700"}`}><Icon className="h-4.5 w-4.5" /></span>}
    </div>
    <div className="font-display text-3xl font-bold text-slate-900 mt-3">{value ?? "—"}</div>
    {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
  </div>
);

export const Empty = ({ title, body, action }) => (
  <div className="cz-card p-10 text-center" data-testid="empty-state">
    <div className="font-display font-semibold text-slate-800">{title}</div>
    {body && <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{body}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const ComingSoon = ({ title, body }) => (
  <div>
    <PageHeader title={title} />
    <div className="cz-card p-10 flex flex-col items-start gap-3 max-w-2xl" data-testid="coming-soon">
      <span className="h-11 w-11 rounded-xl bg-teal-50 text-teal-700 grid place-items-center"><Construction className="h-5 w-5" /></span>
      <div className="font-display text-lg font-semibold text-slate-900">Planned for an upcoming milestone</div>
      <p className="text-slate-600">{body || "The data model for this area is in place. The interface will be delivered after the foundation milestone is reviewed."}</p>
    </div>
  </div>
);

export function ChipSelect({ options, value = [], onChange, testid, single = false }) {
  const toggle = (o) => onChange(single ? o : value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const key = typeof o === "string" ? o : o.value;
        const text = typeof o === "string" ? o : o.label;
        const on = single ? value === key : value.includes(key);
        return (
          <button type="button" key={key} onClick={() => toggle(key)} data-testid={`${testid}-option-${String(key).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={`rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors duration-200 ${on ? "bg-[#003B2D] border-[#003B2D] text-white" : "bg-white border-slate-200 text-slate-700 hover:border-teal-400"}`}>
            {text}
          </button>
        );
      })}
    </div>
  );
}
